import React, { useEffect, useState, useRef } from "react";
import "./listBlog.css";
import "./filter.css";
import { useCounter } from "../../hooks/useCounter";
import { useTranslation } from "react-i18next";
import { useAxios } from "../../hooks/useAxios";
import { useAxios3 } from "../../hooks/useAxios";

import rel from "../../assets/img/relo.png";
import ir from "../../assets/img/ir_acti.png";
import regresa from "../../assets/img/regresa.png";
import regresa2 from "../../assets/img/ir_izq.png";

const Busqueda = ({ cadena, catego, datee, onRetorno=0  }) => {
    const [t, i18n] = useTranslation("ideas_libertad");
    const [t2] = useTranslation("biblioteca");

    console.log("Cadena: " + cadena);

    const { counter, increment, decrement, resetCounter, defaultValue } =
        useCounter(0);

    const inputVal = cadena;

    const categoria = catego;
    const category = catego;

    const [toppage, setToppage] = useState(10);
    const [toppage_mov, setToppage_mov] = useState(4);
    const [ficha, setFicha] = useState(12);

    const [url2, setUrl2] = useState(
        `/blogs/n?offset=${counter * ficha}&next=1&lang=${i18n.language}`
    );

    const [url, setUrl] = useState(
        `/blogs/n?offset=${counter * ficha}&next=12&lang=${i18n.language}`
    );


    const [date, setDate] = useState(null);

    const { data, isLoading, error } = useAxios(url);
    const [blogs, setBlogs] = useState([]);

    const { data2, isLoading2, error2 } = useAxios3(url2);
    const [blogs2, setBlogs2] = useState([]);

    const [pagin, setPagin] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
    const [pagin_mov, setPagin_mov] = useState([1, 2, 3, 4, 5]);

    const formatDate = (date) => {
        const options = { day: "numeric", month: "long", year: "numeric" };
        return new Date(date).toLocaleDateString(i18n.language, options);
    };

    useEffect(() => {
        if (data) {
            setBlogs(data);
        }
    }, [data]);

    useEffect(() => {
        if (data2) {
            setBlogs2(data2);
            const i = Math.ceil(data2.length / 12);
            const newPagin = Array.from({ length: i }, (_, index) => index + 1);

            const i_mov = Math.ceil(data2.length / 6);
            onRetorno(data2.length);

            setPagin(newPagin);
            if (i_mov <= 5) {
                const newPagin2 = Array.from(
                    { length: i_mov },
                    (_, index) => index + 1
                );
                setPagin_mov(newPagin2);
                setToppage_mov(i_mov - 1);
            } else {
                setPagin_mov([1, 2, 3, 4, 5]);
                setToppage_mov(4);
            }

            if (i != 0) {
                setToppage(i - 1);
            } else {
                setToppage(0);
            }
        }
    }, [data2]);

    useEffect(() => {
        if (date === null) {
            if (inputVal.length >= 1) {
                if (category === null) {
                    setUrl(
                        `/blogs/search/by-content?offset=${counter * ficha
                        }&next=${ficha}&lang=${i18n.language}&words=${inputVal}`
                    );
                    setUrl2(
                        `/blogs/search/by-content?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}`
                    );
                } else {
                    setUrl(
                        `/blogs/search/by-content?offset=${counter * ficha
                        }&next=${ficha}&lang=${i18n.language
                        }&words=${inputVal}&category=${category}`
                    );
                    setUrl2(
                        `/blogs/search/by-content?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&category=${category}`
                    );
                }
            }
        } else {
            if (inputVal.length >= 1) {
                if (category === null) {
                    setUrl(
                        `/blogs/search/by-content?offset=${counter * ficha
                        }&next=${ficha}&lang=${i18n.language
                        }&words=${inputVal}&sort=${date}`
                    );
                    setUrl2(
                        `/blogs/search/by-content?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&sort=${date}`
                    );
                } else {
                    setUrl(
                        `/blogs/search/by-content?offset=${counter * ficha
                        }&next=${ficha}&lang=${i18n.language
                        }&words=${inputVal}&category=${category}&sort=${date}`
                    );
                    setUrl2(
                        `/blogs/search/by-content?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&category=${category}&sort=${date}`
                    );
                }
            }
        }
    }, [counter, i18n.language]);


    useEffect(() => {
        if (category && category.length >= 1) {
            setUrl(
                `/blogs/search/by-content?offset=0&next=${ficha}&lang=${i18n.language}&words=${inputVal}&category=${category}`
            );
            setUrl2(
                `/blogs/search/by-content?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&category=${category}`
            );
        }
        else {
            setUrl(
                `/blogs/search/by-content?offset=0&next=${ficha}&lang=${i18n.language}&words=${inputVal}`
            );
            setUrl2(
                `/blogs/search/by-content?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}`
            );
        }
        defaultValue(0);
        goToPage(0);

    }, [inputVal, category]);

    const numero = (txtresumen) => {
        // Verificar si txtresumen es una cadena y no es undefined
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            // Realizar split por "||"
            const partes = txtresumen.split("||");

            // Verificar si hay una segunda parte
            if (partes.length > 1 && partes[1].trim() !== "") {
                return partes[1].trim(); // Si hay una segunda parte, retornarla
            }
        }

        // Si no hay una segunda parte o si txtresumen no es una cadena o es vacío,
        // realizar el cálculo actual
        const i = Math.floor(Math.random() * 5) + 1;
        return i;
    };

    const resumensplit = (txtresumen) => {
        // Verificar si txtresumen es una cadena y no es undefined
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            // Realizar split por "||"
            const partes = txtresumen.split("||");

            // Verificar si hay una segunda parte
            if (partes.length > 1 && partes[0].trim() !== "") {
                return partes[0].trim(); // Si hay una segunda parte, retornarla
            }
        }

        return txtresumen;
    };

    const elementosMostrados = 6;
    const [totalElementos, setTotalElementos] = useState([]);
    const totalPaginas = Math.ceil(blogs2?.length / elementosMostrados);
    const [paginaActual, setPaginaActual] = useState(1);
    const [paginasVisibles, setPaginasVisibles] = useState([]);

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(pagin?.length / itemsPerPage);

    const goToPage = page => {
        setCurrentPage(page);
    };

    const nextButton = vble => {
        if (window.innerWidth <= 768) {
            // Lógica para dispositivos móviles (ancho menor o igual a 768px)
            if (paginaActual != totalPaginas) {
                setFicha(6);
                increment();
                nextPage();
                const targetDivMobile = document.getElementById('id-resultadoss');
                targetDivMobile.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            // Lógica para desktop (ancho mayor a 768px)
            if (counter < toppage) {
                setFicha(12)
                increment();
                setCurrentPage(currentPage + 1);
                const targetDivDesktop = document.getElementById('id-resultadosesc');
                targetDivDesktop.scrollIntoView({ behavior: 'smooth' });
            }
        }

    };

    useEffect(() => {
        const generarPaginasVisibles = () => {
            let paginaInicial, paginaFinal;

            // Caso 1: Menos de 5 páginas en total
            if (totalPaginas <= 5) {
                paginaInicial = 1;
                paginaFinal = totalPaginas;
            } else {
                // Caso 2: Más de 5 páginas en total
                if (paginaActual < 5) {
                    // Estamos en las primeras 5 páginas
                    paginaInicial = 1;
                    paginaFinal = 5;
                } else if (paginaActual + 4 >= totalPaginas) {
                    // Estamos en las últimas 5 páginas
                    paginaInicial = totalPaginas - 4;
                    paginaFinal = totalPaginas;
                } else {
                    // Estamos en el medio de las páginas
                    paginaInicial = paginaActual - 2;
                    paginaFinal = paginaActual + 2;
                }
            }

            // Generar la lista de páginas visibles
            const paginas = [];
            for (let i = paginaInicial; i <= paginaFinal; i++) {
                paginas.push(i);
            }

            setPaginasVisibles(paginas);
        };

        generarPaginasVisibles();
    }, [paginaActual, totalPaginas]);

    const nextPage = () => {
        setPaginaActual(
            paginaActual === totalPaginas ? totalPaginas : paginaActual + 1
        );
    };

    const prevPage = () => {
        setPaginaActual(paginaActual === 1 ? 1 : paginaActual - 1);
    };



    return (
        <>
            {isLoading ? (
                <h1 style={{ marginLeft: "45%" }}> ... </h1>
            ) : (
                <>
                    {blogs.length > 0 ? (
                        <>
                            <h4 className="busquedadiv"><span className="yellow">Blogs {t("filtro.resultados2")}</span></h4>
                            <div className="contenedor_LisBlog escritorio">
                                <div className="row1_LB">
                                    <p className="result">
                                        {t("filtro.mostrar-resultados1")} {((counter) * 12) + (blogs ? blogs.length : 0)}{t2("biblioteca.of")}{(blogs2 ? blogs2.length : 60)}{" "}
                                        {t("filtro.mostrar-resultados2")}
                                    </p>
                                </div>

                                <div className="row2_LB">
                                    <div className="list_content--items">
                                        {blogs.map((item, index) => (
                                            <div key={index} className="card">
                                                <div className="front">
                                                    <img
                                                        className="imgG_LB"
                                                        src={item.urlImagen}
                                                        alt={item.urlImagen}
                                                    />
                                                    <div className="cinta">
                                                        <p className="tit_LB">{item.titulo}</p>
                                                    </div>
                                                </div>

                                                <div className="back">
                                                    <p className="fh_LB"> {formatDate(item.fecha)} </p>
                                                    <p className="catego">
                                                        {item.categorias.map((dat) => dat.nombre).join(" - ")}
                                                    </p>
                                                    <hr className="line_LB"></hr>
                                                    <p className="titu_LB">
                                                        {item.titulo}
                                                        <p className="titu_LB2">{t("filtro.por-rbs")}</p>
                                                    </p>
                                                    <p className="desc_LB">
                                                        {resumensplit(item.resumen).substring(0, 100) + "..."}
                                                    </p>
                                                    <img className="reloj_LB " src={rel} alt="reloj"></img>
                                                    <p className="alineIzq_ub_LB">
                                                        {" "}
                                                        {numero(item.resumen)} {t("filtro.tiempo-lectura")}
                                                    </p>

                                                    <div className="div_bot_LB">
                                                        <a className="buton_LB" target="_blank" href={"/blog/" + item.tag}>
                                                            {t("filtro.leer")}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div id="column-left">
                                        <div className="row6_LB" style={{ cursor: "pointer" }}>
                                            <img
                                                className="imgPag_LB"
                                                onClick={() => {
                                                    console.log(counter);
                                                    console.log(toppage);
                                                    if (counter < toppage) {
                                                        setFicha(12)
                                                        increment();
                                                        setCurrentPage(currentPage + 1);
                                                    }
                                                }}
                                                src={ir}
                                                alt="ir"
                                            />
                                        </div>
                                        <div
                                            className="row6_LB"
                                            onClick={() => {
                                                if (counter > 0) {
                                                    setFicha(12);
                                                    decrement();
                                                    setCurrentPage(currentPage - 1);
                                                }
                                            }}
                                        >
                                            {counter > 0 ? (
                                                <img
                                                    className="imgPag_LB cursorPointer"
                                                    src={regresa2}
                                                    alt="regresa"
                                                />
                                            ) : (
                                                <img className="imgPag_LB" src={regresa} alt="regresa" />
                                            )}
                                        </div>

                                        {pagin.slice(currentPage > 3 ? currentPage - 3 : 0, currentPage > 3 ? currentPage + itemsPerPage - 3 : 10)
                                            .map((item, index) => (
                                                <div
                                                    key={index}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                        setFicha(12);
                                                        defaultValue(item - 1);
                                                        goToPage(item - 1);
                                                    }}
                                                    div
                                                    className="row6_LB"
                                                >
                                                    <p
                                                        className={
                                                            item - 1 === currentPage
                                                                ? "nume numeros_paginado_idea_corta"
                                                                : "nume"
                                                        }
                                                    >
                                                        {item}
                                                    </p>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                                <div className="row3_LB">
                                    <p className="result">
                                        {t("filtro.mostrar-resultados1")} {((counter) * 12) + (blogs ? blogs.length : 0)}{t2("biblioteca.of")}{(blogs2 ? blogs2.length : 60)}{" "}
                                        {t("filtro.mostrar-resultados2")}
                                    </p>
                                </div>
                            </div>
                            <div className="contenedor_LisBlog movil">
                                <div className="column-arriba">
                                    <div className="media-val">
                                        <p className="result">
                                            {t("filtro.mostrar-resultados1")} {((counter) * 6) + (blogs ? blogs.slice(0, 6).length : 0)}{t2("biblioteca.of")}<span className="esp_lblog"><br></br></span>{(blogs2 ? blogs2.length : 60)}{" "}
                                            {t("filtro.mostrar-resultados2")}
                                        </p>
                                    </div>
                                    <div class="contenedor-paginacion-movil">
                                        <div className="contenedor-btn">
                                            <img
                                                className="imagen-izquierda"
                                                onClick={() => {
                                                    if (paginaActual != 1) {
                                                        setFicha(6);
                                                        decrement();
                                                        prevPage();
                                                    }
                                                }}
                                                src={`${paginaActual > 1
                                                    ? "/assets/imgs/detalle_blog/arrow.png"
                                                    : "/assets/imgs/detalle_blog/regresa.png"
                                                    }`}
                                                disabled={paginaActual === 1 ? true : false}
                                            />
                                        </div>
                                        {paginaActual >= 5 && <a>...</a>}
                                        {paginasVisibles.map((page) => (
                                            <a
                                                key={page}
                                                className={`${page === paginaActual
                                                    ? "active numeros_paginado_idea_corta_movil"
                                                    : ""
                                                    }`}
                                                onClick={() => {
                                                    setFicha(6);
                                                    defaultValue(page - 1);
                                                    setPaginaActual(page);
                                                }}
                                            >
                                                {page}
                                            </a>
                                        ))}
                                        {paginaActual < totalPaginas - 4 ? null : <a>...</a>}
                                        <div className="contenedor-btn">
                                            <img
                                                className="imagen-derecha"
                                                onClick={() => {
                                                    if (paginaActual != totalPaginas) {
                                                        setFicha(6);
                                                        increment();
                                                        nextPage();
                                                    }
                                                }}
                                                src={`${paginaActual === totalPaginas
                                                    ? "/assets/imgs/detalle_blog/ir_2.png"
                                                    : "/assets/imgs/detalle_blog/ir_acti.png "
                                                    }`}
                                                disabled={paginaActual === totalPaginas ? true : false}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row2_LB">
                                    <div className="list_content--items">
                                        {blogs.slice(0, 6).map((item, index) => (
                                            <div key={index} className="card">
                                                <div className="front">
                                                    <img
                                                        className="imgG_LB"
                                                        src={item.urlImagen}
                                                        alt={item.urlImagen}
                                                    />
                                                    <div className="cinta">
                                                        <p className="tit_LB">{item.titulo}</p>
                                                    </div>
                                                </div>

                                                <div className="back">
                                                    <p className="fh_LB"> {formatDate(item.fecha)} </p>
                                                    <p className="catego">
                                                        {item.categorias.map((dat) => dat.nombre).join(" - ")}
                                                    </p>
                                                    <hr className="line_LB"></hr>
                                                    <p className="titu_LB">{item.titulo}</p>
                                                    <p className="desc_LB">
                                                        {resumensplit(item.resumen).substring(0, 100) + "..."}
                                                    </p>
                                                    <img className="reloj_LB " src={rel} alt="reloj"></img>
                                                    <p className="alineIzq_ub_LB">
                                                        {" "}
                                                        {numero(item.resumen)} {t("filtro.tiempo-lectura")}
                                                    </p>
                                                    <div className="div_bot_LB">
                                                        <a className="buton_LB" target="_blank" href={"/blog/" + item.tag}>
                                                            {t("filtro.leer")}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="media-val22">
                                    <p className="result">
                                        {t("filtro.mostrar-resultados1")} {((counter) * 6) + (blogs ? blogs.slice(0, 6).length : 0)}{t2("biblioteca.of")}{(blogs2 ? blogs2.length : 60)}{" "}
                                        {t("filtro.mostrar-resultados2")}
                                    </p>
                                </div>
                            </div>
                        </>
                    ) : (
                        <h4 className="no-encontrado">No se encontraron blogs con contenido relacionado</h4>
                    )}
                </>
            )}

        </>);



};

export default Busqueda;
